/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserEntity } from './UserEntity';
import {
    UserEntityFromJSON,
    UserEntityFromJSONTyped,
    UserEntityToJSON,
    UserEntityToJSONTyped,
} from './UserEntity';

/**
 * 
 * @export
 * @interface SlackEntity
 */
export interface SlackEntity {
    /**
     * アクセストークンは秘匿情報なのでここでは扱わない
     * @type {string}
     * @memberof SlackEntity
     */
    tenantId: string;
    /**
     * SlackチャンネルID
     * Slack側で管理されるチャンネルのIDそのもの。
     * @type {string}
     * @memberof SlackEntity
     */
    channelId: string;
    /**
     * チャンネル名
     * @type {string}
     * @memberof SlackEntity
     */
    channelName: string;
    /**
     * 作成日時
     * @type {Date}
     * @memberof SlackEntity
     */
    createdAt: Date;
    /**
     * 最終更新日時
     * @type {Date}
     * @memberof SlackEntity
     */
    updatedAt: Date;
    /**
     * 作成ユーザー
     * @type {UserEntity}
     * @memberof SlackEntity
     */
    createdBy: UserEntity;
    /**
     * 最終更新ユーザー
     * @type {UserEntity}
     * @memberof SlackEntity
     */
    updatedBy: UserEntity;
}

/**
 * Check if a given object implements the SlackEntity interface.
 */
export function instanceOfSlackEntity(value: object): value is SlackEntity {
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('channelId' in value) || value['channelId'] === undefined) return false;
    if (!('channelName' in value) || value['channelName'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    return true;
}

export function SlackEntityFromJSON(json: any): SlackEntity {
    return SlackEntityFromJSONTyped(json, false);
}

export function SlackEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SlackEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'],
        'channelId': json['channelId'],
        'channelName': json['channelName'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'createdBy': UserEntityFromJSON(json['createdBy']),
        'updatedBy': UserEntityFromJSON(json['updatedBy']),
    };
}

export function SlackEntityToJSON(json: any): SlackEntity {
    return SlackEntityToJSONTyped(json, false);
}

export function SlackEntityToJSONTyped(value?: SlackEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'channelId': value['channelId'],
        'channelName': value['channelName'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'createdBy': UserEntityToJSON(value['createdBy']),
        'updatedBy': UserEntityToJSON(value['updatedBy']),
    };
}

